import { Component, OnInit } from '@angular/core';
import {HeaderTitleService} from '../../../layout/content-header/header-title.service';

@Component({
  selector: 'app-mobx-tic-tac',
  templateUrl: './mobx-tic-tac.component.html',
  styleUrls: ['./mobx-tic-tac.component.scss']
})
export class MobxTicTacComponent implements OnInit {

  constructor(private headerTitleService: HeaderTitleService) {
    this.headerTitleService.updateHeaderTitle('Mobx Tic Tac Toe');
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/mobx-tic-tac.component.ts